import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

async function hashIp(ip: string): Promise<string> {
  const data = new TextEncoder().encode(ip);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

export async function trackVisit(): Promise<void> {
  try {
    // if (window.location.hostname === 'localhost') return;

    const res = await fetch('https://api.ipify.org?format=json');
    const { ip } = await res.json();
    const ipHash = await hashIp(ip);

    await addDoc(collection(db, 'visits'), {
      ipHash,
      timestamp: serverTimestamp(),
    });
  } catch (err) {
    console.error('[trackVisit]', err);
  }
}
